import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const BASE_URL = 'https://pkg7axv4xl.execute-api.eu-west-2.amazonaws.com/dev/pdf/html';

@Injectable({
  providedIn: 'root'
})
export class PDFService {

  constructor(
    private http: HttpClient
  ) { }

  htmlToPdf(payload: {html: string}): Observable<Blob> {
    const httpHeaders = new HttpHeaders({
      accept: 'application/pdf'
    });
    const httpOptions = {
      headers: httpHeaders,
      responseType: 'blob' as 'json'
    }
    return this.http.post<Blob>(BASE_URL, payload, httpOptions);
  }

  saveBlob(data: Blob, filename: string) {
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(data);
    link.download = filename;
    link.innerText = 'Download';
    link.click()
  }
}
